import { gsap } from "gsap";

export function heroAnimation() {
  const timeline = gsap.timeline({ defaults: { ease: "power1.out" } });
  timeline
    .from(
      ".hero_content h1",
      {
        duration: 1,
        translateY: "80px",
        opacity: 0,
      },
      0
    )
    .from(
      ".hero_content p",
      {
        duration: 0.8,
        opacity: 0,
      },
      1
    )
    .from(
      ".hero_content a",
      {
        duration: 0.8,
        opacity: 0,
      },
      1.4
    );
  return timeline;
}

export function aboutHeadingAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "#about",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#aboutHeading span",
      {
        duration: 1,
        scaleX: 0,
        transformOrigin: "left",
      },
      0
    )
    .from(
      "#aboutHeading h3",
      {
        duration: 1,
        opacity: 0,
      },
      0.5
    )
    .from(
      "#aboutHeading h2",
      {
        duration: 1,
        opacity: 0,
      },
      0.8
    )
    .from(
      ".about_content",
      {
        duration: 1,
        opacity: 0,
      },
      1.2
    );
  return timeline;
}

export function skillsHeadingAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: ".skills_container",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#skillsHeading span",
      {
        duration: 1,
        scaleX: 0,
        transformOrigin: "left",
      },
      0
    )
    .from(
      "#skillsHeading h3",
      {
        duration: 1,
        opacity: 0,
      },
      0.5
    )
    .from(
      "#skillsHeading h2",
      {
        duration: 1,
        opacity: 0,
      },
      0.8
    );
  return timeline;
}

export function frontendSkillAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "#frontendSkills",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#frontendSkills .skill_icon",
      {
        duration: 0.6,
        translateY: "20px",
        opacity: 0,
      },
      0.8
    )
    .from(
      "#frontendSkills .skill_heading",
      {
        duration: 0.6,
        translateY: "20px",
        opacity: 0,
      },
      1
    )
    .from(
      "#frontendSkills .skill_list_item",
      {
        duration: 0.3,
        translateY: "10px",
        opacity: 0,
        stagger: 0.4,
      },
      1.2
    );
  return timeline;
}

export function backendSkillAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "#backendSkills",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#backendSkills .skill_icon",
      {
        duration: 0.6,
        translateY: "20px",
        opacity: 0,
      },
      0.8
    )
    .from(
      "#backendSkills .skill_heading",
      {
        duration: 0.6,
        translateY: "20px",
        opacity: 0,
      },
      1
    )
    .from(
      "#backendSkills .skill_list_item",
      {
        duration: 0.3,
        translateY: "10px",
        opacity: 0,
        stagger: 0.4,
      },
      1.2
    );
  return timeline;
}

export function otherSkillAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "#otherSkills",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#otherSkills .skill_icon",
      {
        duration: 0.6,
        translateY: "20px",
        opacity: 0,
      },
      0.8
    )
    .from(
      "#otherSkills .skill_heading",
      {
        duration: 0.6,
        translateY: "20px",
        opacity: 0,
      },
      1
    )
    .from(
      "#otherSkills .skill_list_item",
      {
        duration: 0.3,
        translateY: "10px",
        opacity: 0,
        stagger: 0.4,
      },
      1.2
    );
  return timeline;
}

export function portfolioHeadingAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "#portfolio",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#portfolioHeading span",
      {
        duration: 1,
        scaleX: 0,
        transformOrigin: "left",
      },
      0
    )
    .from(
      "#portfolioHeading h3",
      {
        duration: 1,
        opacity: 0,
      },
      0.5
    )
    .from(
      "#portfolioHeading h2",
      {
        duration: 1,
        opacity: 0,
      },
      0.8
    );
  return timeline;
}

export function movieAppAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "#movieApp",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#movieApp .portfolio_title",
      {
        duration: 1,
        opacity: 0,
      },
      0.5
    )
    .from(
      "#movieApp .portfolio_details",
      {
        duration: 1,
        opacity: 0,
      },
      1
    )
    .from(
      "#movieApp .portfolio_image",
      {
        duration: 0.6,
        translateX: "110%",
      },
      1.3
    );
  return timeline;
}

export function restaurantAppAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "#restaurant",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#restaurant .portfolio_title",
      {
        duration: 1,
        opacity: 0,
      },
      0.5
    )
    .from(
      "#restaurant .portfolio_details",
      {
        duration: 1,
        opacity: 0,
      },
      1
    )
    .from(
      "#restaurant .portfolio_image",
      {
        duration: 0.6,
        translateX: "110%",
      },
      1.3
    );
  return timeline;
}

export function invoiceAppAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "#invoice",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#invoice .portfolio_title",
      {
        duration: 1,
        opacity: 0,
      },
      0.5
    )
    .from(
      "#invoice .portfolio_details",
      {
        duration: 1,
        opacity: 0,
      },
      1
    )
    .from(
      "#invoice .portfolio_image",
      {
        duration: 0.6,
        translateX: "110%",
      },
      1.3
    );
  return timeline;
}

export function feedbackAppAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "#feedback",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#feedback .portfolio_title",
      {
        duration: 1,
        opacity: 0,
      },
      0.5
    )
    .from(
      "#feedback .portfolio_details",
      {
        duration: 1,
        opacity: 0,
      },
      1
    )
    .from(
      "#feedback .portfolio_image",
      {
        duration: 0.6,
        translateX: "110%",
      },
      1.3
    );
  return timeline;
}

export function crmAppAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "#crm",
      start: "top 80%",
    },
  });
  timeline
    .from(
      "#crm .portfolio_title",
      {
        duration: 1,
        opacity: 0,
      },
      0.5
    )
    .from(
      "#crm .portfolio_details",
      {
        duration: 1,
        opacity: 0,
      },
      1
    )
    .from(
      "#crm .portfolio_image",
      {
        duration: 0.6,
        translateX: "110%",
      },
      1.3
    );
  return timeline;
}

export function footerAnimation() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: ".myFooter",
      start: "top 50%",
    },
  });
  timeline
    .from(
      ".myFooter h2",
      {
        duration: 1,
        translateY: "20px",
        opacity: 0,
      },
      0.5
    )
    .from(
      ".myFooter p",
      {
        duration: 1,
        translateY: "20px",
        opacity: 0,
      },
      0.8
    )
    .from(
      ".social a",
      {
        duration: 0.5,
        translateY: "20px",
        opacity: 0,
        stagger: 0.3,
      },
      1
    )
    .from(
      "#hireMe",
      {
        duration: 0.6,
        opacity: 0,
        translateY: "20px",
      },
      1.5
    );
  return timeline;
}

export function initAnimations() {
  heroAnimation();
  aboutHeadingAnimation();
  skillsHeadingAnimation();
  frontendSkillAnimation();
  backendSkillAnimation();
  otherSkillAnimation();
  footerAnimation();
  portfolioHeadingAnimation();
  movieAppAnimation();
  restaurantAppAnimation();
  invoiceAppAnimation();
  feedbackAppAnimation();
  crmAppAnimation();
}
